(function MediaHubMediaTagForm($, Adzuki)
{
	const component = {
		emits : ['close-sidebar', 'cancel'],
		inject: ['openToast', 'openAlert'],
		props : {
			mediaTag: {
				type   : Object,
				default: () => ({})
			},
			// a new tag starts global when Home Office adds it from the Global tab (MEDIA-290)
			defaultGlobal: {
				type   : Boolean,
				default: false
			},
			// every tag on the page, to check a new name against (MEDIA-312)
			existingTags: {
				type   : Array,
				default: () => []
			},
		},
		template: '#mediatag-form',
		data() {
			return {
				tagForm: {
					id         : null,
					name       : '',
					description: '',
					isGlobal   : 0,
				},
				errors       : {},
				saving       : false,
				// look-alike tags found on Save; saving the same name again confirms (MEDIA-312)
				duplicates   : [],
				duplicatesFor: null
			};
		},
		computed: {
			duplicateNote() {
				return this.duplicates.length ? Adzuki.MediaTagDuplicates.describe(this.duplicatesFor, this.duplicates) : '';
			},
			duplicateFiles() {
				return this.duplicates.slice(0, 3).map((tag) => {
					const files = ['image', 'video', 'doc'].reduce((total, type) => total
						+ (Number(tag[type + '_count']) || 0)
						+ (Number(tag[type + '_att_count']) || 0), 0);

					return '“' + tag.name + '” is on ' + files + (files === 1 ? ' file' : ' files');
				}).join(' · ');
			},
			// files using the tag being edited; a file has one type, so the counts add up
			usedOn() {
				const tag = this.mediaTag || {};

				if (!tag.id) {
					return 0;
				}

				// Media Library and Attachments counts (MEDIA-311)
				return ['image', 'video', 'doc'].reduce((total, type) => total
					+ (Number(tag[type + '_count']) || 0)
					+ (Number(tag[type + '_att_count']) || 0), 0);
			}
		},
		methods: {
			validateForm() {
				this.errors = {};

				// Validate required fields
				if (!this.tagForm.name || this.tagForm.name.trim() === '') {
					this.errors.name = 'Name is required';
				} else if (this.tagForm.name.includes(',')) {
					this.errors.name = 'Tag names cannot contain commas';
				} else if (this.tagForm.name.includes(':|:')) {
					this.errors.name = 'Tag names cannot contain ":|:"';
				}

				return Object.keys(this.errors).length === 0;
			},
			saveTag() {
				this.errors = {};

				// the error shows under the field (MEDIA-290)
				if (!this.validateForm()) {
					return;
				}

				// a new name that looks like another tag asks first; a second Save confirms
				const name    = this.tagForm.name.trim();
				const renamed = !this.tagForm.id || name.toLowerCase() !== String(this.mediaTag.name || '').trim().toLowerCase();

				if (renamed && this.duplicatesFor !== name) {
					const matches = Adzuki.MediaTagDuplicates.similarTo(name, this.existingTags, this.tagForm.id);

					if (matches.length) {
						this.duplicates    = matches;
						this.duplicatesFor = name;
						return;
					}
				}

				this.saving = true;

				const formData = new FormData();

				if (this.tagForm.id) {
					formData.append('id', this.tagForm.id);
				}
				formData.append('name', this.tagForm.name);
				formData.append('description', this.tagForm.description);
				formData.append('global', this.tagForm.isGlobal ? 1 : 0);

				fetch(this.$baseUri + '/MediaTag/manageTag/', {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						this.saving = false;

						if (data && data.error) {
							this.errors = { name: data.error };
							return;
						}
						if (this.tagForm.id) {
							this.openAlert('success', 'Success', 'Media Tag updated successfully');
						} else {
							this.openAlert('success', 'Success', 'Media Tag saved successfully');
						}
						this.tagForm = {};
						this.$emit('close-sidebar');
					})
					.catch(error => {
						this.saving = false;
						this.openAlert('error', 'Error', String(error));
					});
			},
			// always a full reset: an empty tag is Add, and a global tag keeps its flag when
			// edited (it used to save as global = 0 and drop out of the Global tab)
			initializeForm() {
				const tag = this.mediaTag || {};

				this.errors  = {};
				this.tagForm = {
					id         : tag.id || null,
					name       : tag.name || '',
					description: tag.description || '',
					isGlobal   : tag.id ? String(tag.global) === '1' : this.defaultGlobal,
				};
			},
			clearError(field) {
				if (this.errors[field]) {
					delete this.errors[field];
				}
			}
		},
		watch: {
			// a changed name is checked again on the next Save
			'tagForm.name'(name) {
				if (this.duplicatesFor !== null && String(name || '').trim() !== this.duplicatesFor) {
					this.duplicates    = [];
					this.duplicatesFor = null;
				}
			},
			mediaTag: {
				handler(newVal) {
					this.initializeForm();
				},
				deep: true
			}
		},
		mounted() {
			this.initializeForm();
		}
	};

	Adzuki.VueComponents.MediaHubMediaTagForm = component;
}(jQuery, window.Adzuki || {}));
